<template>
  <b-row>
    <b-col cols="12">
      <collapse-description />
      <!-- <collapse-sample /> -->
      <collapse-default />
      <accordion-default />
      <collapse-styles />
      <collapse-hover />
      <collapse-boostrap-vue />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import CollapseDescription from './CollapseDescription.vue'
// import CollapseSample from './CollapseSample.vue'
import AccordionDefault from './AccordionDefault.vue'
import CollapseDefault from './CollapseDefault.vue'
import CollapseBoostrapVue from './CollapseBootstrapVue.vue'
import CollapseStyles from './CollapseStyles.vue'

export default {
  components: {
    BRow,
    BCol,

    CollapseDescription,
    // CollapseSample,
    AccordionDefault,
    CollapseDefault,
    CollapseBoostrapVue,
    CollapseStyles,
  },
}
</script>
